import { ItemStatus } from "@focus/focusUI";


// STATUS PROXY
export function combineStatuses(statuses: ItemStatus[]): ItemStatus {
  if (statuses.some((s) => s === ItemStatus.PENDING)) return ItemStatus.PENDING;
  if (statuses.some((s) => s === ItemStatus.ERROR)) return ItemStatus.ERROR;
  return ItemStatus.READY;
}

export function combineErrors(errors: Array<string | undefined | null>): string | undefined {
  const filtered = errors.filter((e): e is string => Boolean(e));

  if (filtered.length === 0) return undefined;
  if (filtered.length === 1) return filtered[0];

  return filtered.join("\n");
}

export function combineNamedErrors(errors: Record<string, string | undefined>): string | undefined {
  const entries = Object.entries(errors)
    .filter(([_, err]) => Boolean(err))
    .map(([name, err]) => `${name}: ${err}`);

  if (entries.length === 0) return undefined;
  return entries.join("\n");
}
